import React from "react";
import { Input, Button } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { observer } from "mobx-react";

interface ListInputProps {
  value?: string[];
  max?: number;
  onChange?: (value: string[]) => void;
}

export const ListInput = observer(({ value = [""], max = 9999, onChange }: ListInputProps) => {
  const onValue = (i, val) => {
    value[i] = val;
    onChange && onChange([...value]);
  };

  const onAdd = () => {
    onChange && onChange([...value, ""]);
  };

  const onDel = (i) => {
    value.splice(i, 1);
    onChange && onChange([...value]);
  };

  return (
    <div>
      <div>
        {value.map((x, i) => (
          <Input
            addonAfter={value.length > 1 && <DeleteOutlined onClick={() => onDel(i)} />}
            key={i + ""}
            value={x}
            onChange={(e) => onValue(i, e.target.value)}
            allowClear={true}
          />
        ))}
      </div>
      {value.length < max && (
        <div style={{ textAlign: "right" }}>
          <Button onClick={onAdd}>+</Button>
        </div>
      )}
    </div>
  );
});
